import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminCompanyLogos = lazy(() => import("@/pages/admin/AdminCompanyLogos"));

export const Route = createFileRoute("/admin/logotyper")({
  component: () => <AdminCompanyLogos />,
});
